import React from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import HomeSceneWrapper from '@Components/HomeSceneWrapper'
import TabsWrapperComponent, { Tab } from '@Components/TabsWrapperComponent'
import MemberInternalScene from '@Scenes/HomeInternalScene/MemberInternalScene'
import SongwriterInternalScene from '@Scenes/HomeInternalScene/SongwriterInternalScene'

const HomeInternalScene = () => {
    const internalHomeTabs: Tab[] = [
        {
            tabName: 'Members',
            tabDisplayName: 'Members',
            tabComponent: <MemberInternalScene />,
        },
        {
            tabName: 'Songwriters',
            tabDisplayName: 'Songwriters',
            tabComponent: <SongwriterInternalScene />,
        },
    ]

    return (
        <>
            <title>Home</title>
            <HomeSceneWrapper
                header={
                    <>
                        <h1>Welcome to The MLC Admin Portal</h1>
                    </>
                }
            >
                <div className="release-notes-section">
                    <Link
                        className="release-link"
                        to="https://themlccom.sharepoint.com/sites/Portal/SitePages/Portal-Release-Notes-History.aspx"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Release Notes
                    </Link>
                </div>
                <TabsWrapperComponent tabs={internalHomeTabs} defaultTab={internalHomeTabs[0]} preventScrollReset />
            </HomeSceneWrapper>
        </>
    )
}

export default observer(HomeInternalScene)
